webpackJsonp([183505435639452],{

/***/ 1677:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Cage","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"maxWeight","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"minWeight","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"species","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-cage-53dd4cc67b4e7060188c.js